import {setCookie} from "@js/globalFunctions/cookieHandling";

export function defineCurrentPagingByRequestHeaders( request )
{
	var currentPaging = request.getResponseHeader('x-esbs-paging');
	if( typeof currentPaging !== 'undefined' )
	{
		dataholder.currentLocalPaging = currentPaging;
		setCookie('tempContentHolderPaging',Number(currentPaging),1);
	}
}
